/**
 *Created by jmmartinez on 03/05/19
 *
 * v 1.1 30/09/2019 Modificado para usar el nombre del paquete dinámicamente en la deteccion de clases.
 * v 1.2 04/06/2020 Modificad la función  getItemSelectedFromEnumValue para añadir casos y darle seguridad.
 * v.2.0 30/09/2020 Cambiado a framework2
 * v.2.1 02/12/2020 Import "../../resources/css/combobox.css" para que coja el popoverClass
 * v.2.2 13/07/2021 Añadida propiedad: modo35 para tenerlo en cuenta al cargar los datos.
 *                  Correcciones globales de funcionamiento
 * v.2.3 05/09/2023 Cambiado para usar el nuevo combox basado en react-select
 *                  Creadas nuevas propiedades label y labelInline
 * */

import React from 'react'
import PropTypes from 'prop-types';
import "../../resources/css/combobox.css";

//import ComboBox from "../../blueprint/ComboBox";
import ComboBox from "./ComboBox";
import ClienteRestful from "../network/ClienteRestful";
import {filtrarConNombreCampo} from "../utils/FilterUtils"
import {nombrePaquete} from "../../../dental/Configuracion";


class ComboBoxEnum extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            id: props.id,
            placeholder: props.placeholder,
            className: props.className,
            enumClase: props.enumClase,
            enumValue: props.enumValue,
            enumCodigo: props.enumCodigo,
            elementos: [{}],
            label: props.label,
            labelInline: props.labelInline,
        }
    }

    componentDidMount() {
        const {id, className, placeholder, enumClase, enumValue} = this.props;

        this.setState({
            id: id,
            className: className,
            enumClase: enumClase,
            enumValue: enumValue,
            placeholder: placeholder,
            elementos: [],
        }, () => this.load());

    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.enumClase !== prevState.enumClase) {
            newState.enumClase = nextProps.enumClase;
        }
        if (nextProps.enumValue !== prevState.enumValue) {
            newState.enumValue = nextProps.enumValue;
        }

        /*
        if (nextProps.enumCodigo !== prevState.enumCodigo) {
            newState.enumCodigo = nextProps.enumCodigo;
        }
       */

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    load = () => {
        const {enumClase, enumValue} = this.state;
        const {urlServicioRestful, filtro, modo35} = this.props;
        let pos= nombrePaquete.length;
        let claseSimple= enumClase.substr(pos);
        let modo35Real= modo35 ? Boolean(modo35) : false;
        const url= urlServicioRestful + "list/" + claseSimple;
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doPost( filtro, response => {
            if (clienteRestful.exito && response){
                let newElementos= response;
                if (modo35Real)
                    newElementos= response.lo;

                //console.log ("LOADED");
                let elementoSeleccionado= this.getItemSelectedFromEnumValue(newElementos, enumValue);
                //console.log("enumValue: ", enumValue);
                //console.log("elementoSeleccionado: ", elementoSeleccionado);
                //console.log("enumCodigo: ", elementoSeleccionado.codigo);
                this.setState({elementos: newElementos, enumCodigo: elementoSeleccionado.codigo});
            }
        });
    }

    onValueChanged= (objeto) => {
        const {onValueChanged} = this.props;
        const {elementos} = this.state;
        //console.log("onValueChanged: ", objeto);
        this.setState({enumCodigo: objeto.codigo});
        onValueChanged && onValueChanged(objeto);
    }

    getItemSelectedFromEnumValue= (elementos, enumValue) => {
        if (elementos && enumValue) {
            let items = filtrarConNombreCampo(elementos, "nombre", enumValue);
            if (items && items.length > 0)
                return items[0];
            else
                return null;
        }
        else{
            if (elementos && elementos.length > 0)
                return elementos[0];
        }
        return null;
    }

    getItemSelectedFromEnumCodigo= (elementos, enumCodigo) => {
        //console.log("getItemSelectedFromEnumCodigo");
        //console.log("id: " + this.props.id);
        //console.log("enumCodigo: ", enumCodigo);
        if (elementos && enumCodigo) {
            let items = filtrarConNombreCampo(elementos, "codigo", enumCodigo);
            if (items && items.length > 0)
                return items[0];
            else
                return null;
        }
        else{
            if (elementos && elementos.length > 0)
                return elementos[0];
        }
        return null;
    }

    render() {
        const {id, placeholder, elementos, enumValue, enumCodigo, label, labelInline} = this.state;
        //let itemSelected= this.getItemSelectedFromEnumValue(elementos, enumValue);
        let itemSelected= this.getItemSelectedFromEnumCodigo(elementos, enumCodigo);

        /*
        console.log("COMBOBOXENUM - render");
        console.log("elementos: ", elementos);
        console.log("enumCodigo: ", enumCodigo);
        console.log("itemSelected: ", itemSelected);
        */

        return (
            <div>
            {   elementos && elementos.length > 0 &&
                <ComboBox
                    id= {id}
                    fieldText="nombre"
                    fieldKey="codigo"
                    items={elementos}
                    onValueChanged={this.onValueChanged}
                    placeholder= {placeholder}
                    filterable={false}
                    popoverClassName="popover"
                    itemSelected= {itemSelected}
                    label={label}
                    labelInline={labelInline}
                />
            }
            </div>
        );
    }
}


ComboBoxEnum.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    onValueChanged: PropTypes.func,
    placeholder: PropTypes.string,
    enumClase: PropTypes.string.isRequired,
    enumValue: PropTypes.string,
    enumCodigo: PropTypes.number,
    urlServicioRestful: PropTypes.string.isRequired,
    modo35: PropTypes.bool,
    label: PropTypes.string,
    labelInline: PropTypes.bool,
}

export default ComboBoxEnum;